"use client";

import React, { useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ClientSuccessStories() {
  const watermarkRef = useRef<HTMLDivElement>(null);
  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!watermarkRef.current) return;
    const {
      clientX,
      clientY
    } = e;
    const moveX = (clientX / window.innerWidth - 0.5) * 40;
    const moveY = (clientY / window.innerHeight - 0.5) * 40;
    watermarkRef.current.style.transform = `translate(${moveX}px, ${moveY}px)`;
  };
  return <section data-section-id="222908" id="itinerari" className="dark relative min-h-screen w-full overflow-hidden flex items-center justify-center bg-black" onMouseMove={handleMouseMove}>
      {}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat opacity-60 grayscale" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648136/img/ortigara.png)"
    }} aria-hidden="true" />
      <div className="absolute inset-0 z-1 bg-black/40" aria-hidden="true" />

      {}
      <div ref={watermarkRef} className="pointer-events-none absolute inset-0 z-2 flex items-center justify-center transition-transform duration-1000 ease-out" aria-hidden="true">
        <span className="text-[25vw] font-serif font-bold leading-none tracking-tighter text-white/[0.03] select-none">
          ALPINI
        </span>
      </div>

      {}
      <div className="container relative z-10 mx-auto px-6 text-center !bg-transparent !text-[rgba(239,67,67,1)]">
        <div className="max-w-3xl mx-auto space-y-8">
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl font-light tracking-tight text-foreground animate-in fade-in slide-in-from-bottom-4 duration-700">Monte Ortigara<br /><span className="text-primary italic" data-ast-id="f:/src/pages/Home/sections/ClientSuccessStories.tsx|sig:55x7uv" data-ast-start="1924" data-ast-end="1993">Il Calvario degli Alpini</span></h2>
          
          <p className="font-serif text-lg md:text-xl text-muted-foreground leading-relaxed animate-in fade-in slide-in-from-bottom-6 duration-1000 delay-200">
            Tra le rocce scheggiate e il silenzio assordante delle vette, sorge la Colonna Mozza. 
            Un monumento perenne a chi ha combattuto in una delle battaglie più cruente della Grande Guerra, 
            dove il coraggio si è fuso con il sacrificio estremo.
          </p>

          <div className="pt-4 animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-500">
            <Button asChild variant="outline" size="lg" className="rounded-none border-primary/50 hover:border-primary hover:bg-primary/10 text-primary px-8 py-6 text-lg tracking-widest uppercase transition-all duration-300">
              <Link to="/MountOrtigaraPage">
                Leggi la Storia
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}